import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=0a66a25b"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports